import React, { useEffect, useState } from "react";
import "../styles/BulkEmail.css";
// material ui components
import SubjectIcon from "@mui/icons-material/Subject";
import {
  Button,
  TextField,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { Alert } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

// material ui components end here
import { EditorState, convertToRaw } from "draft-js";
import "../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import axios from "axios";
import draftToHtml from "draftjs-to-html";
import { ApiURL } from "../constants/ApiUrl";
import { Box } from "@material-ui/core";

// function starts here
export default function BulkEmail() {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [subject, setSubject] = useState("");
  const [msg, setMsg] = useState("");
  const [testemails, setTestemails] = useState("");
  const [option, setOption] = useState("");
  const [docstatus, setDocstatus] = useState("");
  // custom lines of code
  const handleSubjectChange = (e) => {
    console.log(e.target.value);
    setSubject(e.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const htmlData = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    let emailData = {};

    emailData = {
      subject: subject,
      testemails: testemails.split(",").map((email) => {
        return { Email: email.trim() };
      }),
      docstatus: docstatus,
      html: htmlData,
    };
    if (emailData.testemails[0].Email === "") {
      delete emailData.testemails;
    }

    // console.log(emailData);
    try {
      const response = await axios.post(
        `${ApiURL}/api/send_emails`,
        emailData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.code === 200) {
        setMsg("success");
      }
    } catch (err) {
      setMsg("failure");
    }
  };
  const onEditorStateChange = (newChange) => {
    setEditorState(newChange);
  };
  const handleClose = () => {
    setMsg("");
  };
  const handleTestemailChange = (e) => {
    setTestemails(e.target.value);
    setDocstatus("");
  };
  const handleDocStatusChange = (e) => {
    setDocstatus(e.target.value);
    setTestemails("");
  };

  // console.log(convertToRaw(editorState.getCurrentContent()));

  return (
    <>
      <div className="BulkEmailMain">
        <div className="form-container">
          <h1 id="heading">
            Schedule Emails to <span>Members</span>
          </h1>
          {msg === "success" || msg === "failure" ? (
            msg === "success" ? (
              <Alert
                variant="filled"
                severity="success"
                sx={{ margin: "1rem auto 0 auto", width: "50%" }}
                action={
                  <Button onClick={handleClose} color="inherit" size="small">
                    <CloseIcon />
                  </Button>
                }
              >
                Email has been scheduled.
              </Alert>
            ) : (
              <Alert
                variant="filled"
                severity="error"
                sx={{ margin: "1rem auto 0 auto", width: "50%" }}
                action={
                  <Button onClick={handleClose} color="inherit" size="small">
                    <CloseIcon />
                  </Button>
                }
              >
                Error occurred, Please try again!
              </Alert>
            )
          ) : null}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <TextField
                onChange={handleSubjectChange}
                variant="outlined"
                label="Subject"
                id="outlined-basic"
                placeholder="Enter subject here"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SubjectIcon />
                    </InputAdornment>
                  ),
                }}
                required
              ></TextField>
            </div>
            <div className="form-group">
              <FormControl component="fieldset">
                <FormLabel component="legend">Send Emails To:</FormLabel>
                <RadioGroup
                  row
                  aria-label="email-options"
                  // name="email-options"
                  name="row-radio-buttons-group"
                  value={option}
                  onChange={(e) => setOption(e.target.value)}
                >
                  <FormControlLabel
                    value="testemails"
                    control={<Radio />}
                    label="Test Emails"
                  />
                  <FormControlLabel
                    value="docstatus"
                    control={<Radio />}
                    label="Based on Docstatus"
                  />
                </RadioGroup>
              </FormControl>
              <div className="form-email-group">
                {option === "testemails" && (
                  <TextField
                    fullWidth
                    required
                    onChange={handleTestemailChange}
                    variant="outlined"
                    label="Test Emails"
                    id="outlined-basic"
                    placeholder="Enter test email"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachEmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  ></TextField>
                )}
                {option === "docstatus" && (
                  <>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="select-label">Doc Status</InputLabel>
                      <Select
                        fullWidth
                        required
                        labelId="select-label"
                        id="simple-select"
                        value={docstatus}
                        label="Status"
                        onChange={handleDocStatusChange}
                        variant="outlined"
                      >
                        <MenuItem value="">
                          <em>Select from below list</em>
                        </MenuItem>
                        <MenuItem value={"doctor"}>Doctor</MenuItem>
                        <MenuItem value={"student"}>Student</MenuItem>
                      </Select>
                    </FormControl>
                  </>
                )}
              </div>
            </div>

            <div className="mt-5 border border-2 border-dark form-group">
              <Editor
                editorState={editorState}
                editorStyle={{ border: "1px solid", height: 300 }}
                toolbarStyle={{ border: "1px solid" }}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={onEditorStateChange}
              />
            </div>
            <Box
              sx={{
                marginTop: "1rem",
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Button variant="contained" type="submit" color="primary">
                Schedule
              </Button>
            </Box>
          </form>
        </div>
      </div>
    </>
  );
}
